<!--
 * @Author: your name
 * @Date: 2020-10-27 16:31:00
 * @LastEditTime: 2020-11-03 15:54:46
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ShopExpressEdition/src/components/advisory/advisoryDetail/recomendDoctorRes.vue
-->
<template>
  <div style="margin-top: 20px">
    <detailTitle
      title="门店推荐"
      :check="checkControl.recommandProduct"
      :prop="checkControl.recommandProductProp"
      v-on="$listeners"
    />
    <div class="recomend-container">
      <el-table :data="commodity">
        <el-table-column
          align="center"
          prop="commodity_name"
          label="产品"
        ></el-table-column>
        <el-table-column align="center" prop="number" label="数量">
        </el-table-column>
        <el-table-column
          align="center"
          prop="price"
          label="单价"
        ></el-table-column>
        <el-table-column align="center" prop="price_now" label="现价">
        </el-table-column>
        <el-table-column align="center" prop="price_total" label="总价">
        </el-table-column>
      </el-table>
    </div>
    <div v-if="totalPrice" class="white-block">总计：{{ totalPrice }}元</div>
    <!-- <div class="btn-box">
      <el-button
        type="primary"
        style="margin-right:100px;background:#4b90ff;color:#fff"
        icon="el-icon-printer"
        round
        >A4纸打印</el-button
      >
      <el-button
        icon="el-icon-printer"
        type="primary"
        style="background:#4b90ff;color:#fff"
        round
        >小票机打印</el-button
      >
    </div> -->
  </div>
</template>
<script>
import detailTitle from './detailTitle';

export default {
  components: {
    detailTitle
  },
  props: {
    commodity: {}
  },
  data() {
    return {
      checkControl: {
        recommandProduct: false,
        recommandProductProp: 'recommandProduct',
        productList: false,
        productListProp: 'productList'
      }
    };
  },
  computed: {
    totalPrice() {
      if (this.commodity.length) {
        const arr = this.commodity.map(item => parseFloat(item.price_total));
        return arr.reduce((total, currentValue) => total + currentValue, 0);
      }
      return 0;
    }
  }
};
</script>
<style lang="scss" scoped>
.recomend-container {
  padding: 20px 30px;
  background-color: #fff;
}
.btn-box {
  margin-top: 20px;
  display: flex;
  background-color: #fff;
  height: 80px;
  justify-content: center;
  align-items: center;
}
</style>
